// Avoid dependency import cycles
import type { PulseError } from '@prenuvo/pulse';

import { REDIRECT_TIMEOUT } from '../../../shared/constant/redirect.constant';
import { redirect } from '../../../shared/util/redirect.util';
import { useAuthStore } from '../../../store/use-auth-store';

export const authInterceptorHandler = (error: PulseError) => {
  const status = error?.response?.status;

  if (status && [401, 403].includes(status)) {
    const currentState = useAuthStore.getState();

    // Only set state and schedule redirect if not already handling this error
    // This prevents multiple timeouts from being set if the interceptor is called multiple times
    if (!currentState.showUnauthenticatedToast) {
      // Set showUnauthenticatedToast immediately to signal that error interceptor is handling redirect
      // This prevents AuthGuard from redirecting immediately
      useAuthStore.setState({
        showUnauthenticatedToast: true,
      });

      // Delay setting isAuthenticated to false and redirecting to allow toast to be displayed
      // By keeping isAuthenticated true until the timeout, AuthGuard won't redirect immediately
      setTimeout(() => {
        useAuthStore.setState({
          isAuthenticated: false,
        });

        redirect.toLogin();
      }, REDIRECT_TIMEOUT.UNAUTHENTICATED);
    }
  }

  return Promise.reject(error);
};
